const knownObjProps = {
	"style": 1,
	"dataset": 1,
};

/**
* @typedef {
* 	Record<string, string> & {
* 		style: Record<string, any>,
* 		dataset: Record<string, any>
* 		on: Record<string, EventListener>
* 	}
* } AttrInit
*/
/**
 * @type {{
 *		(tagName: string, attributes: AttrInit, ...content: (string|Node|false|null|undefined)[]) => HTMLElement
 *		(tagName: string, ...content: (string|Node|false|null|undefined)[]) => HTMLElement
 * }}
 */
// const createElement is essential to document parameter overloads
const createElement = function createElement(tagName/* [, attributes: AttrInit][, ...content: string|Node] */) {
	const element = document.createElement(tagName);
	let i = 1, arg = arguments[i];
	if (arg?.toString() === "[object Object]") {
		Object.entries(arg).forEach(([k, v]) => {
			if (!(k in knownObjProps) && k !== "on" && v != null && v !== false) {
				element.setAttribute(k, v === true ? "" : v);
			}
		});
		for (const propName in knownObjProps) {
			const argProp = arg[propName];
			if (argProp?.toString() === "[object Object]") {
				const prop = element[propName];
				Object.entries(argProp).forEach(([k, v]) => { prop[k] = v; });
			}
		}
		if (arg.on) {
			for (const event in arg.on) {
				element.addEventListener(event, arg.on[event]);
			}
		}
		i++;
	}
	for (; i < arguments.length; i++) {
		arg = arguments[i];
		if (arg != null && arg !== false)
			element.append(arg);
	}
	return element;
};

function findChild(element, selector) {
	if (element) {
		for (let e = element.firstElementChild; e; e = e.nextElementSibling)
			if (e.matches(selector))
				return e;
	}
	return null;
}

function findChildren(element, selector) {
	const result = [];
	if (element) {
		for (let e = element.firstElementChild; e; e = e.nextElementSibling)
			if (e.matches(selector))
				result.push(e);
	}
	return result;
}

/**
 * @param {Element} element
 * @param {String} html
 */
function setElementHtml(element, html) {
	const template = document.createElement("template");
	template.innerHTML = html;
	// we can perform any cleanup here
	element.replaceChildren(template.content);
}

function onEvent(context, selector, events, fn) {
	context = context || document;
	function handler(e) {
		for (let el = e.target; el != context && el != null; el = el.parentNode) {
			if (el.matches(selector)) {
				fn.call(el, e, el);
				if (e.cancelBubble)
					break;
			}
		}
	}
	events.split(' ').forEach(event => context.addEventListener(event, handler));
}

const rgValidId = /[A-Za-z][A-Za-z0-9_:.-]*/;

function getById(context, id) {
	return rgValidId.test(id) ? (context || document).querySelector(`#${id}`) : null;
}


const uniqueId = (function () {
	let globalCount = 0;
	return function (element, prefix) {
		if (typeof element === "string") {
			prefix = element;
			element = null;
		}
		if (element && element.id)
			return element.id;
		const uniqueId = `${prefix || "uid"}-${new Date().valueOf()}-${++globalCount}`;
		if (element)
			element.id = uniqueId;
		return uniqueId;
	};
})();

export { createElement, getById, findChild, findChildren, onEvent, uniqueId, setElementHtml };